import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GoalsKeys } from "web_myplann/Api/Goals/GoalsKeys";
import {
	type GoalCompletionStateEnum,
	type GoalDetailResponseDTO,
	putGoalIdStateV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type GoalStateVariables = {
	id: number;
	state: GoalCompletionStateEnum;
};

export const useGoalStateMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<
		GoalDetailResponseDTO | undefined,
		Error,
		GoalStateVariables
	>({
		mutationFn: processResponse(({ id, state }: GoalStateVariables) =>
			putGoalIdStateV2({ state }, id),
		),
		onSuccess: (data, variables) => {
			if (data) {
				queryClient.setQueryData<GoalDetailResponseDTO>(
					GoalsKeys.detail(variables.id),
					data,
				);
			} else {
				queryClient.invalidateQueries({
					queryKey: GoalsKeys.detail(variables.id),
				});
			}
			queryClient.invalidateQueries({ queryKey: GoalsKeys.lists() });
			queryClient.invalidateQueries({ queryKey: GoalsKeys.detailPortfolios() });
		},
	});
};
